export default {
  dataIterator: {
    rowsPerPageText: 'Qillqatanaka mä janana:',
    rowsPerPageAll: 'Taqi qillqatanaka',
    pageText: '{0}-{1} jana {2} jana(naka)ta',
    noResultsText: `Janiwa wakt'añanakaxa utjkiti`,
    nextPage: 'Nayraqata jana',
    prevPage: 'Jutiri jana'
  },
  dataTable: {
    rowsPerPageText: 'Jana siqichaña:'
  },
  noDataText: 'Yatiyawixa janiw askikiti'
};



// WEBPACK FOOTER //
// ./src/common/lang/ay/vuetify.js